import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';


const formatCurrency = (value) => {
  if (value === '' || value === null || value === undefined || isNaN(value)) return '';
  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);

  return formatted.replace('€', '€ ');
};


const ObrasTable = ({ obras, openModal, setCurrentPage, currentPage }) => {
  // const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // console.log('Obras recibidas:', obras);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const pageCount = Math.max(1, Math.ceil(obras.length / itemsPerPage));
  const offset = currentPage * itemsPerPage;
  const currentObras = obras.slice(offset, offset + itemsPerPage);

    // const handlePageClick = ({ selected }) => {
    // setCurrentPage(selected);
    // };

  return (
    <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
      {isMobile ? (
        <div className="p-3 sm:p-4 md:p-6">
          <div className="flex flex-col gap-3 sm:gap-4">
            {currentObras.map((obra) => (
            <div
              key={obra.IdObra}
              className="group bg-white rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 shadow-sm border border-gray-200 hover:shadow-lg hover:border-purple-200 transition-all duration-300 cursor-pointer"
              onClick={() => openModal(obra)}
              title="Editar Obra"
            >
              {/* Header de la card */}
              <div className="flex items-start justify-between mb-3 sm:mb-4">
                <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
                  <div className="p-2 sm:p-3 bg-purple-50 rounded-lg sm:rounded-xl group-hover:bg-purple-100 transition-colors flex-shrink-0">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-semibold text-gray-800 text-base sm:text-lg truncate">{obra.Comercial || '-'}</h3>
                    <p className="text-blue-600 font-medium text-sm truncate">{obra.Constructora || '-'}</p>
                  </div>
                </div>
                <div className="p-1.5 sm:p-2 bg-green-50 rounded-lg flex-shrink-0">
                  <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>

              {/* Información principal */}
              <div className="grid grid-cols-1 gap-2 sm:gap-3 mb-3 sm:mb-4">
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Obra</span>
                  <span className="font-medium text-gray-800 text-sm truncate max-w-[60%] text-right">{obra.Obra || '-'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Fecha Visita</span>
                  <span className="font-medium text-gray-800 text-sm">{obra.FechaVisita ? new Date(obra.FechaVisita).toLocaleDateString('es-ES') : '-'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Técnico Comercial</span>
                  <span className="font-medium text-gray-800 text-sm truncate max-w-[60%] text-right">{obra.TecnicoComercial || '-'}</span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xs sm:text-sm text-gray-500">Contacto</span>
                  <span className="font-medium text-gray-800 text-sm truncate max-w-[60%] text-right">{obra.NombreCV || '-'}</span>
                </div>
              </div>

              {/* Badges y información adicional */}
              <div className="flex flex-wrap gap-1.5 sm:gap-2 mb-2 sm:mb-3">
                <span className="inline-flex items-center px-2 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 truncate max-w-[45%]">
                  {obra.EstadoObra || '-'}
                </span>
                <span className="inline-flex items-center px-2 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 truncate max-w-[45%]">
                  {obra.Poblacion || '-'}
                </span>
                {obra.Nombre && (
                  <span className="inline-flex items-center px-2 sm:px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 truncate max-w-[45%]">
                    {obra.Nombre}
                  </span>
                )}
              </div>

              {/* Footer con información adicional */}
              <div className="pt-2 sm:pt-3 border-t border-gray-100">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-1 sm:gap-2 text-xs text-gray-600">
                  <span className="truncate">Zona: <span className="font-medium">{obra.Subdivision || '-'}</span></span>
                  <span className="truncate">Teléfono: <span className="font-medium">{obra.TelefonoCV || '-'}</span></span>
                </div>
                {obra.ObservacionesCV && (
                  <div className="mt-1.5 sm:mt-2">
                    <span className="text-xs text-gray-500">Comentarios: </span>
                    <span className="text-xs text-gray-600 italic break-words">
                      {obra.ObservacionesCV.length > 40
                        ? `${obra.ObservacionesCV.slice(0, 40)}...`
                        : obra.ObservacionesCV}
                    </span>
                  </div>
                )}
              </div>
            </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="overflow-auto">
          <table className="min-w-[900px] table-auto w-full">
            <thead className="sticky top-0 z-10 bg-gray-50 border-b border-gray-200">
              <tr className="bg-gradient-to-r from-purple-50 to-purple-100 border-b-2 border-purple-200">
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Comercial</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Constructora</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Obra</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Fecha Visita</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Estado Obra</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Zona</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Población</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Técnico Comercial</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Observaciones C</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Contacto Visitado</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Teléfono CV</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Email CV</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Dirección Obra</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Tipo Material</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Tipo Obra</th>
                <th className="px-4 py-3 text-left font-semibold text-gray-700 text-sm">Observaciones Obra</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {currentObras.map((obra, index) => (
                <tr
                  key={obra.IdObra}
                  className={`cursor-pointer hover:bg-purple-50 group transition-colors duration-200 ${
                    index % 2 === 0 ? 'bg-white' : 'bg-gray-50'
                  }`}
                  onClick={() => openModal(obra)}
                  title="Editar Obra"
                >
                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-medium text-gray-800 group-hover:text-purple-600">
                    {obra.Comercial || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-medium text-gray-800 group-hover:text-purple-600">
                    {obra.Constructora || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-medium text-gray-800">
                    {obra.Obra || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {obra.FechaVisita ? new Date(obra.FechaVisita).toLocaleDateString('es-ES') : '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                    <span className="px-2 py-1 bg-purple-100 text-purple-800 rounded-lg text-xs font-medium">
                      {obra.EstadoObra || '-'}
                    </span>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                    <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-lg text-xs font-medium">
                      {obra.Subdivision || '-'}
                    </span>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                    <span className="px-2 py-1 bg-gray-200 text-gray-700 rounded-lg text-xs font-medium">
                      {obra.Poblacion || '-'}
                    </span>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {obra.TecnicoComercial || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    <div className="max-w-[120px] truncate" title={obra.ObservacionesC || ''}>
                      {obra.ObservacionesC || '-'}
                    </div>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {obra.NombreCV || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {obra.TelefonoCV || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {obra.EmailCV || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    <div className="max-w-[150px] truncate" title={`${obra.CalleObra || ''} ${obra.NumeroObra || ''}, ${obra.PoblacionObra || ''}`}>
                      {obra.CalleObra && obra.NumeroObra ? `${obra.CalleObra} ${obra.NumeroObra}, ${obra.PoblacionObra || ''}` : '-'}
                    </div>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    {obra.TipoMaterial || '-'}
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    <div className="max-w-[100px] truncate" title={obra.Nombre || ''}>
                      {obra.Nombre || '-'}
                    </div>
                  </td>
                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-gray-700">
                    <div className="max-w-[120px] truncate" title={obra.ObservacionesCV || ''}>
                      {obra.ObservacionesCV || '-'}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Paginación */}
      <div className="flex flex-col sm:flex-row justify-center sm:justify-between items-center sm:gap-3 sm:gap-4 p-3 sm:p-4 bg-gray-50 border-t border-gray-200">
        <div className="flex items-center gap-2 sm:gap-3 p-3 md:p-0">
          <label className="text-xs sm:text-sm font-medium text-gray-700">Items por página:</label>
          <div className="flex items-center gap-1">
            {[5, 10, 20].map(size => (
              <button
                key={size}
                onClick={() => {
                  setItemsPerPage(size);
                  setCurrentPage(0);
                }}
                className={`px-2 sm:px-3 py-1 sm:py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 ${
                  itemsPerPage === size
                    ? 'bg-purple-600 text-white shadow-sm'
                    : 'bg-white text-gray-700 border border-gray-200 hover:bg-purple-50 hover:border-purple-300'
                }`}
              >
                {size}
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-3 p-1 md:p-0">
          <button 
            onClick={() => setCurrentPage(0)} 
            disabled={currentPage === 0} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-purple-50 hover:border-purple-300 transition-all duration-200 shadow-sm"
          >
            <ChevronsLeft size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
          <button 
            onClick={() => setCurrentPage((prev) => prev - 1)} 
            disabled={currentPage === 0} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-purple-50 hover:border-purple-300 transition-all duration-200 shadow-sm"
          >
            <ChevronLeft size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
          
          <span className="px-2 sm:px-4 py-1.5 sm:py-2 bg-purple-50 border border-purple-200 rounded-lg sm:rounded-xl text-xs sm:text-sm font-medium text-purple-800">
            {currentPage + 1} / {pageCount}
          </span>
          
          <button 
            onClick={() => setCurrentPage((prev) => prev + 1)} 
            disabled={currentPage >= pageCount - 1} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-purple-50 hover:border-purple-300 transition-all duration-200 shadow-sm"
          >
            <ChevronRight size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
          <button 
            onClick={() => setCurrentPage(pageCount - 1)} 
            disabled={currentPage >= pageCount - 1} 
            className="p-1.5 sm:p-2 border border-gray-200 rounded-lg sm:rounded-xl disabled:opacity-50 disabled:cursor-not-allowed hover:bg-purple-50 hover:border-purple-300 transition-all duration-200 shadow-sm"
          >
            <ChevronsRight size={14} className="sm:w-4 sm:h-4 text-gray-600" />
          </button>
        </div>
      </div>
    </div>
  );  

};

export default ObrasTable;
